import React from "react";
import { Row, Col } from "react-bootstrap";
import { Progress, Tooltip, Button } from "antd";

const statusColor = {
  active: "#FFA500", // orange
  critical: "#FF4D4F", // red
  completed: "#52C41A", // green
};

const ProjectCard = ({
  data,
  onAnalyze,
  onReport,
  onDownload,
  onShare,
  onEdit,
  onSummary,
  onDelete,
}) => {
  const {
    name,
    status = "active",
    date,
    category,
    timestamp,
    overall,
    value,
    assets,
    loss,
    riskType,
  } = data;

  const scoreColor = {
    low: "#52C41A",
    medium: "#FAAD14",
    high: "#FF4D4F",
  };

  const riskLabel =
    overall < 20 ? "low risk" : overall < 60 ? "medium risk" : "high risk";

  return (
    <div className="project-card-modern">
      <div className="project-card-header">
        <div className="project-title">{name}</div>
        <div className="project-date" style={{ float: "right" }}>
          {new Date(date).toLocaleDateString()}
        </div>
      </div>
      <br />
      <div className="project-score-section">
        <div
          className="score-label"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1em",
          }}
        >
          <span>Climate Score</span>

          <div
            className="score-value"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span>{overall}%</span>
            <span className={`risk-pill ${riskLabel.replace(" ", "-")}`}>
              {riskLabel}
            </span>
          </div>
        </div>

        <Progress
          percent={overall}
          strokeColor={scoreColor[riskLabel.split(" ")[0]]}
          showInfo={false}
        />
      </div>

      <br />
      <Row className="score-panels">
        <Col xs={4}>
          <div className="score-block secondary">
            <div className="score-type">Assets</div>
            <div className="score-value">{assets}</div>
          </div>
        </Col>
        <Col xs={4}>
          <div className="score-block primary">
            <div className="score-type">Maximum Exposure</div>
            {value ? (
              <div className="score-value">
                {value >= 1000
                  ? `$${(value / 1000).toFixed(2)} B`
                  : `$${value.toFixed(2)} M`}
              </div>
            ) : null}
          </div>
        </Col>
        <Col xs={4}>
          <div className="score-block secondary">
            <div className="score-type">RCVaR</div>
            {loss ? (
              <div className="score-value">
                {loss >= 1000
                  ? `$${(loss / 1000).toFixed(2)} B`
                  : `$${loss.toFixed(2)} M`}
              </div>
            ) : null}
          </div>
        </Col>
      </Row>
      <br />
      <Row className="action-buttons">
        <Col xs={6}>
          <Button className="btn-analyze" onClick={onAnalyze}>
            Analyse
          </Button>
        </Col>
        <Col xs={6}>
          <Button className="btn-report" onClick={onReport}>
            Report
          </Button>
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col lg={12} style={{ textAlign: "center" }}>
          <Row>
            <Col>
              <Tooltip title="Download">
                <i
                  className="bi bi-download"
                  onClick={onDownload}
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                ></i>
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Download Summary">
                <i
                  className="bi bi-file-earmark-text"
                  onClick={onSummary}
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                ></i>
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Delete">
                <i
                  className="bi bi-trash"
                  onClick={onDelete}
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                ></i>
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Edit">
                <i
                  className="bi bi-pencil-square"
                  onClick={onEdit}
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                ></i>
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Share">
                <i
                  className="bi bi-share"
                  onClick={onShare}
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                ></i>
              </Tooltip>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectCard;
